export default __webpack_public_path__ + "static/media/img8.2e652b26.png";